module.exports = __webpack_public_path__ + "710cbefe9f071cc5013f1e40a7a5e45a.svg";